module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("ihcwB"))).then(() => parcelRequire('2MuLE'));